import React, { useState } from 'react';

const SimplePago = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const crearPago = async () => {
    setLoading(true);
    setError(null);

    try {
      console.log('🚀 Creando pago de prueba...');

      // Datos del pago
      const preferenceData = {
        items: [
          {
            title: "Plan Constructora - Prueba",
            quantity: 1,
            unit_price: 1000,
            currency_id: "ARS"
          }
        ],
        back_urls: {
          success: window.location.origin + "/success",
          failure: window.location.origin + "/failure", 
          pending: window.location.origin + "/pending"
        },
        auto_return: "approved",
        external_reference: "test-" + Date.now(),
        statement_descriptor: "CONSTRUCTORA TEST"
      };

      console.log('📦 Datos del pago:', preferenceData);

      // 🚀 LLAMADA REAL AL BACKEND
      const response = await fetch('http://localhost:3001/api/create-preference', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(preferenceData)
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();

      if (!result.success) {
        throw new Error(result.error || 'Error desconocido del servidor');
      }

      console.log('✅ Pago REAL creado exitosamente:', result);
      
      // Mostrar el resultado real y redirigir
      const confirmRedirect = window.confirm(`✅ ¡Pago REAL creado! 
      
🆔 ID de preferencia: ${result.preference_id}
💰 Monto: $1,000 ARS
🧪 Ambiente: SANDBOX (dinero ficticio)

🔗 ¿Quieres ir al checkout de Mercado Pago para completar el pago de prueba?

✅ Sí - Ir a pagar
❌ No - Solo ver resultado`);

      if (confirmRedirect) {
        // Redirigir al checkout real de Mercado Pago
        window.location.href = result.sandbox_init_point;
      } else {
        alert(`🎉 ¡Perfecto! El backend está funcionando.

📋 Datos del pago:
- ID: ${result.preference_id}
- URL de pago: ${result.sandbox_init_point}

🎯 ¡Ya puedes procesar pagos reales de prueba!`);
      }

    } catch (error) {
      console.error('❌ Error creando pago:', error);
      setError('Error al crear el pago: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ 
      padding: '20px', 
      maxWidth: '500px', 
      margin: '20px auto',
      fontFamily: 'Arial, sans-serif'
    }}>
      <h2>💳 Pago Simple de Prueba</h2>
      
      <div style={{ 
        background: '#f8f9fa', 
        padding: '20px', 
        borderRadius: '8px',
        marginBottom: '20px',
        border: '1px solid #dee2e6'
      }}>
        <h3>🛒 Producto de prueba</h3>
        <div style={{ fontSize: '18px', marginBottom: '10px' }}>
          <strong>Plan Constructora - Prueba</strong>
        </div>
        <div style={{ fontSize: '24px', color: '#28a745', fontWeight: 'bold' }}>
          $1,000 ARS
        </div>
        <div style={{ fontSize: '14px', color: '#6c757d', marginTop: '5px' }}>
          ✅ Pago de prueba con dinero ficticio
        </div>
      </div>

      {error && (
        <div style={{ 
          background: '#f8d7da', 
          color: '#721c24', 
          padding: '12px', 
          borderRadius: '4px',
          marginBottom: '20px',
          border: '1px solid #f5c6cb'
        }}>
          ❌ {error}
        </div>
      )}

      <div style={{ textAlign: 'center' }}>
        <button
          onClick={crearPago}
          disabled={loading}
          style={{
            background: loading ? '#6c757d' : '#007bff',
            color: 'white',
            border: 'none',
            padding: '15px 30px',
            borderRadius: '6px',
            fontSize: '16px',
            cursor: loading ? 'not-allowed' : 'pointer',
            transition: 'background-color 0.3s'
          }}
        >
          {loading ? '⏳ Creando pago...' : '💳 Crear Pago de Prueba'}
        </button>
      </div>

      <div style={{ 
        marginTop: '20px', 
        padding: '15px',
        background: '#d1ecf1',
        borderRadius: '8px',
        border: '1px solid #bee5eb'
      }}>
        <h4>📝 ¿Qué hace este botón?</h4>
        <ul style={{ marginBottom: '10px' }}>
          <li>✅ Crea los datos del pago correctamente</li>
          <li>🔄 Simula la llamada al backend</li>
          <li>📱 Te muestra la URL donde irías a pagar</li>
          <li>🎯 ¡El siguiente paso es crear el backend real!</li>
        </ul>
        
        <div style={{ fontSize: '12px', color: '#0c5460' }}>
          <strong>Nota:</strong> Por ahora es una simulación. Una vez que funcione, 
          crearemos el backend para procesar pagos reales de prueba.
        </div>
      </div>
    </div>
  );
};

export default SimplePago; 